<template>
  <div class="page">
    <transition
      :enter-active-class="$store.state.enterClassName"
      :leave-active-class="$store.state.leaveClassName"
    >
      <keep-alive>
        <router-view @loaded="loaded"></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Company',

  methods: {
    loaded(data) {
      this.$emit('loaded', data);
    }
  }
};
</script>
